import {
  differenceInDays,
  differenceInHours,
  differenceInMinutes,
} from "date-fns";
import { useEffect, useState } from "react";

export const removeNullProps = (obj: any) => {
  return Object.keys(obj)
    .map((key) => ({ key, value: obj[key] }))
    .reduce((t, e) => {
      if (e.value) {
        t[e.key] = e.value;
      }
      return t;
    }, {});
};

export const removeNullUndefinedProps = (obj) => {
  return Object.keys(obj)
    .map((key) => ({ key, value: obj[key] }))
    .reduce((t, e) => {
      if (e.value !== null && e.value !== undefined && e.value !== "") {
        t[e.key] = e.value;
      }
      return t;
    }, {});
};

export const generateSequentialArray = (length: number) => {
  return new Array(length).fill(null).map((_, i) => i);
};

export const useGetTimeLabel = (created_at) => {
  const [timeAgo, setTimeAgo] = useState("");

  useEffect(() => {
    setTimeAgo(getTimeLabel(created_at));
  }, [created_at]);

  return timeAgo;
};

export const getTimeLabel = (created_at) => {
  const now = new Date();
  const creationDate = new Date(created_at);
  const diffInDays = differenceInDays(now, creationDate);
  let timeAgo = "";
  if (diffInDays === 1) {
    timeAgo = "1 día";
  } else if (diffInDays > 1) {
    timeAgo = `${diffInDays} días`;
  } else {
    const diffInHours = differenceInHours(now, creationDate);
    if (diffInHours === 1) {
      timeAgo = "1 hora";
    } else if (diffInHours > 1) {
      timeAgo = `${diffInHours} horas`;
    } else {
      const diffInMinutes = differenceInMinutes(now, creationDate);
      if (diffInMinutes === 1) {
        timeAgo = "1 minuto";
      } else if (diffInMinutes > 1) {
        timeAgo = `${diffInMinutes} minutos`;
      } else {
        timeAgo = "instantes";
      }
    }
  }
  return timeAgo;
};
